<div class="inicio">

  <div class="div">
  <p class="titulo">SOLICITUDES DE {{tipoSolicitud}} </p>

            <div class="div">

              <!--Barra de búsqueda-->
              <div class="grid-container2">
                  <mat-form-field>
                      <mat-label>BUSCAR</mat-label>
                      <input matInput  (keyup)="applyFilterA($event)"  placeholder="INGRESE DATO A BUSCAR">
                  </mat-form-field>
              </div>

              <!--Boton Descargar reporte--
              <div class="grid-container5">
                  <button mat-raised-button color="primary"> REPORTE
                      <mat-icon> file_download </mat-icon>
                  </button>&nbsp;
              </div> -->

              <!--Tabla-->
              <mat-progress-bar *ngIf="expression" mode="indeterminate"></mat-progress-bar>
              <table mat-table [dataSource] = "dataSourceA"  class="mat-elevation-z8">
                  <ng-container matColumnDef="opciones">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
                      <td mat-cell *matCellDef="let element"> <p></p>
                          <button mat-mini-fab style="background-color: #0804e9;" (click)="detalleSolicitud(element.id_solicitud)"> <span class="material-icons">visibility</span> </button>
                          <p></p>
                      </td>
                  </ng-container>
                  <ng-container matColumnDef="nomColaborador">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
                      <td mat-cell *matCellDef="let element">  {{element.name_colaborador_id}} </td>
                  </ng-container><br>
                  <ng-container matColumnDef="nomPuesto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_cargo_colaborador}}  </td>
                  </ng-container>
                  <ng-container matColumnDef="name_sucursalCol">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL DEL COLABORADOR </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_sucursalCol}} </td>
                  </ng-container>
                  <ng-container matColumnDef="name_tipo_solicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.name_tipo_solicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="nomSolicitante">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SOLICITANTE </th>
                    <td mat-cell *matCellDef="let element"> {{element.name_solicitante_id}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaSolicitud">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
                      <td mat-cell *matCellDef="let element"> {{element.fechaSolicitud}} </td>
                  </ng-container>
                  <ng-container matColumnDef="fechaModificacion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE MODIFICACIÓN </th>
                    <td mat-cell *matCellDef="let element"> {{element.fechaModificacion}} </td>
                  </ng-container>
                  <ng-container matColumnDef="status_solicitud">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS </th>
                    <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>

              </table>
              <mat-paginator #paginatorA class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
          </div>
</div>
</div>
